export const CAPSULE_TAG = {
  mu: 'Market',
  account: 'Account',
  opportunity: 'Oppor.',
  owner: 'Owner',
  document: 'Doc.',
};
